import templateUrl from './sub-feature-repository-edit.html';

export const subFeatureRepositoryEditComponent = {
	bindings: {
                details: '<',
                onSubmit: '&',
                onCancel: '&',
                pageTitle: '@',
                disableButtons: '<'
	},
	templateUrl,
	controller: class subFeatureRepositoryEditComponent {
        }
}


// WEBPACK FOOTER //
// ./src/app/common/components/sub-feature-repository/sub-feature-repository-edit/sub-feature-repository-edit.component.js